import PersonOutlineOutlined from "@mui/icons-material/PersonOutlineOutlined";
import FavoriteBorderOutlined from "@mui/icons-material/FavoriteBorderOutlined";
import ContactSupportOutlined from "@mui/icons-material/ContactSupportOutlined";
import GppGoodOutlined from "@mui/icons-material/GppGoodOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import { MenuItem } from "../menuPanel/MenuRow";
import { useDesktopSideBarLogic } from "../sideBar/desktopSideBar/hooks/useDesktopSideBarLogic";

const ICON_SIZE = 16;

export interface ProfileMenuSection {
  heading: string;
  items: MenuItem[];
}

export function useProfileMenuItems(): { flatItems: MenuItem[]; sections: ProfileMenuSection[] } {
  const { handleSelect } = useDesktopSideBarLogic();

  const profile: MenuItem = {
    icon: <PersonOutlineOutlined color="inherit" sx={{ fontSize: ICON_SIZE }} />,
    label: "Profile",
    onClick: () => handleSelect("Profile"),
  };
  const preferences: MenuItem = {
    icon: <FavoriteBorderOutlined color="inherit" sx={{ fontSize: ICON_SIZE }} />,
    label: "Preferences",
    onClick: () => handleSelect("Preferences"),
  };
  const support: MenuItem = {
    icon: <ContactSupportOutlined color="inherit" sx={{ fontSize: ICON_SIZE }} />,
    label: "Support",
    onClick: () => handleSelect("Support"),
  };
  const privacy: MenuItem = {
    icon: <GppGoodOutlined color="inherit" sx={{ fontSize: ICON_SIZE }} />,
    label: "Privacy Policy",
    onClick: () => handleSelect("Privacy Policy"),
  };
  const terms: MenuItem = {
    icon: <InfoOutlined color="inherit" sx={{ fontSize: ICON_SIZE }} />,
    label: "Terms of Use",
    onClick: () => handleSelect("Terms of Service"),
  };
  const logout: MenuItem = {
    icon: <LogoutOutlined color="inherit" sx={{ fontSize: ICON_SIZE }} />,
    label: "Log out",
    onClick: () => handleSelect("Log out"),
  };

  const flatItems: MenuItem[] = [profile, preferences, support, privacy, terms, logout];
  const sections: ProfileMenuSection[] = [
    { heading: "You", items: [profile, preferences, logout] },
    { heading: "Help", items: [support] },
    { heading: "Legal", items: [privacy, terms] },
  ];

  return { flatItems, sections };
}
